module.exports = __webpack_public_path__ + "img/horizontal_4_6_9016.064cabcc.png";